module.exports = __webpack_public_path__ + "static/media/mode-513.226b56f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-513.svg
// module id = 1043
// module chunks = 2